import React from 'react';

import {
  HeroArea,
  HeroContainer,
  HeroContent,
  HeroTitle,
  HeroDescription,
  NavigationGrid,
  NavTile,
  NavTileIcon,
  NavTileTitle,
  NavTileDescription
} from './style';

const Hero = () => (
  <HeroArea>
    <HeroContainer>
      <HeroContent>
        <HeroTitle>Welcome to poq Docs</HeroTitle>
        <HeroDescription>
          Everything you need to build, customize, and grow your poq app. Find guides, references, and resources to get started.
        </HeroDescription>

        <NavigationGrid>
          <NavTile to="/app-manager">
            <NavTileIcon className="poqstudio">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98L2.57 14.02c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.13-.22.07-.49-.12-.64l-2.11-1.65Z"/>
              </svg>
            </NavTileIcon>
            <NavTileTitle>poqstudio</NavTileTitle>
            <NavTileDescription>Manage your app and its content</NavTileDescription>
          </NavTile>
          
          <NavTile to="/developers">
            <NavTileIcon className="developers">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
              </svg>
            </NavTileIcon>
            <NavTileTitle>Developers</NavTileTitle>
            <NavTileDescription>Build and customise poq apps</NavTileDescription>
          </NavTile>
          
          <NavTile to="/ecosystem">
            <NavTileIcon className="ecosystem">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </NavTileIcon>
            <NavTileTitle>Ecosystem</NavTileTitle>
            <NavTileDescription>Integrate with our wide selection of partners</NavTileDescription>
          </NavTile>
          
          <NavTile to="/app-marketing">
            <NavTileIcon className="marketing">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"/>
              </svg>
            </NavTileIcon>
            <NavTileTitle>App Marketing</NavTileTitle>
            <NavTileDescription>Grow your audience</NavTileDescription>
          </NavTile>
          
          <NavTile to="/support">
            <NavTileIcon className="help">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
              </svg>
            </NavTileIcon>
            <NavTileTitle>Help</NavTileTitle>
            <NavTileDescription>Get support with your poq app</NavTileDescription>
          </NavTile>
        </NavigationGrid>
      </HeroContent>
    </HeroContainer>
  </HeroArea>
);

export default Hero;
